import { Button, Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/ReportAction";

export const ReportListing = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [day, setDay] = useState("0");
  const [openDate, setOpenDate] = useState(false);
  const reportState = useSelector(({ report }) => report, shallowEqual);

  const handleCloseDate = () => {
    setOpenDate(false);
  };

  useEffect(() => {
    const params = {
      action: "memberreport",
      day,
    };

    dispatch(actions.getReportPageList(params));
  }, [day]);

  return (
    <div>
      <div style={styles.navBar} className="position-relative">
        <div className="text-font4" style={styles.title}>
          {intl.formatMessage({ id: "report" })}
        </div>
      </div>
      <div className="mt-3">
        {reportState.reportPageList ? (
          <>
            <div
              className="col-3 mb-3 text-font3"
              style={{
                border: "1px solid white",
                padding: "5px 0 5px 0",
                borderRadius: "5px",
                color: "white",
                marginLeft: "10px",
                textAlign: "center",
              }}
              onClick={() => setOpenDate(true)}
            >
              {reportState.reportPageList.dayFilters
                .filter((reportDate) => reportDate.day === day)
                .map((reportDate, index) => (
                  <div key={index} value={reportDate.day}>
                    {reportDate.daydesccription}
                  </div>
                ))}
            </div>
            {reportState.listLoading ? (
              <div className="d-flex align-items-center justify-content-center py-5">
                <div
                  className="spinner-border"
                  role="status"
                  style={{ scale: "1.2" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div style={{ minHeight: "600px" }}>
                {reportState.reportPageList.memberReports.length > 0 ? (
                  <div>
                    {reportState.reportPageList.memberReports.map(
                      (report, index) => (
                        <div
                          className="card mb-2"
                          key={index}
                          style={{ width: "95%", margin: "0 auto" }}
                        >
                          <div
                            className="card-body rounded"
                            style={{
                              background: "rgba(46, 50, 58, 1)",
                              color: "white",
                            }}
                          >
                            <div className="d-flex justify-content-between">
                              <div className="text-font2">
                                {report.actiondescription}
                              </div>
                              <div>
                                <div
                                  className={`mb-2 text-end fw-bold text-font2`}
                                >
                                  {report.amount}
                                </div>
                                <div className="text-muted fst-italic text-font1">
                                  {report.datetime}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <div className="d-flex py-5 align-items-center justify-content-center">
                    <div className="text-muted d-flex align-items-center justify-content-center flex-column">
                      <i
                        style={{ color: "white" }}
                        className="bi bi-search fs-1 mb-3"
                      />
                      <div className="text-font2" style={{ color: "white" }}>
                        {intl.formatMessage({ id: "noRecordFound" })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            <Drawer
              anchor="bottom"
              open={openDate}
              onClose={handleCloseDate}
              style={{ minHeight: "40vh" }}
            >
              <div style={{ backgroundColor: "#1c1e23", padding: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Button onClick={handleCloseDate}>
                    <FiArrowLeft style={{ color: "white" }} />
                  </Button>
                  <div
                    style={{ flex: 7, color: "white" }}
                    className="text-font4"
                  >
                    {intl.formatMessage({ id: "option" })}
                  </div>
                  <div style={{ flex: 2 }}></div>
                </div>
                <div
                  style={{
                    color: "white",
                    cursor: "pointer",
                    width: "100%",
                    paddingTop: "20px",
                  }}
                  className="text-font3"
                >
                  {reportState.reportPageList &&
                    reportState.reportPageList.dayFilters.map(
                      (reportDate, index) => (
                        <div
                          key={index}
                          value={reportDate.day}
                          onClick={() => {
                            setDay(reportDate.day);
                            handleCloseDate();
                          }}
                          style={{
                            width: "100%",
                            height: "40px",
                            display: "flex",
                            cursor: "pointer",
                          }}
                        >
                          {reportDate.daydesccription}
                        </div>
                      )
                    )}
                </div>
              </div>
            </Drawer>
          </>
        ) : (
          <>
            <Skeleton height="50px" className="col-3 mb-4" />
            <Skeleton height="500px" className="w-100" />
          </>
        )}
      </div>
    </div>
  );
};
const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
